/**
 * Detects the per-company duplicate-email rejection from the contact-update
 * endpoint used by the "Different Address" mismatch modal.
 *
 * When the reply's address already belongs to another contact in the company,
 * the backend returns HTTP 400 with the offending email slot as the field key
 * — `{ email_work | email_personal | email_generic: "Email exists for another
 * contact." }` (see
 * server/contacts/api_views/contacts/contacts_base_view.py
 * `_handle_email_validation_error`). The modal submits exactly one email slot,
 * so a body carrying any of those keys is the in-use case.
 */
const EMAIL_SLOT_KEYS = ['email_work', 'email_personal', 'email_generic']

export function isEmailAlreadyInUseError(error: unknown): boolean {
  const data = (error as { response?: { data?: unknown } } | null)?.response
    ?.data
  if (data == null || typeof data !== 'object') return false
  return EMAIL_SLOT_KEYS.some(
    (key) => typeof (data as Record<string, unknown>)[key] === 'string'
  )
}
